import { jsx as C } from "react/jsx-runtime";
import "react";
var t = (o) => /* @__PURE__ */ C("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ C("path", {
    d: "M15.1412 0H4.85876C2.18079 0 0 2.18079 0 4.85876V15.1412C0 17.8192 2.18079 20 4.85876 20H5.48023C5.53672 19.9548 5.59322 19.8983 5.64972 19.8531L12.2147 14.3729L7.18644 14.3503C5.75141 14.3503 4.85876 13.7062 4.85876 12.5537C4.85876 11.8757 5.16384 11.2655 6.0113 10.4746L10.7345 6.0791H5.9096C4.97175 6.0791 4.36158 5.48023 4.36158 4.56497C4.36158 3.68362 4.96045 3.05085 5.9096 3.05085H14.5763C14.6102 3.05085 14.6328 3.05085 14.6667 3.05085C15.2316 3.07345 15.6836 3.32203 15.9435 3.71751C16.0678 3.9435 16.1356 4.19209 16.1356 4.45198C16.1356 4.96045 15.9209 5.37853 15.4237 5.83051L15.3446 5.89831L8.77966 11.7853L14 11.8079C15.3446 11.8079 16.1808 12.565 16.1808 13.6271C16.1808 14.2599 15.9548 14.9266 14.8362 15.887L10.0791 20H15.1412C17.8192 20 20 17.8192 20 15.1412V4.85876C20 2.18079 17.8192 0 15.1412 0Z",
    fill: "currentColor"
  })
});
export {
  t as default
};
